.avatar {
  position: relative;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--accent-subtle);
  border: 1px solid var(--accent-border);
  color: var(--accent);
  font-weight: var(--weight-semibold);
  text-transform: uppercase;
  flex-shrink: 0;
  overflow: hidden;
  user-select: none;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.loading {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, var(--bg-inset) 0%, var(--bg-hover) 40%, var(--bg-inset) 80%);
  background-size: 300% 100%;
  animation: ela-shimmer 1.4s ease-in-out infinite;
}

.sm {
  width: 30px;
  height: 30px;
  font-size: var(--text-xs);
}

.md {
  width: 44px;
  height: 44px;
  font-size: var(--text-base);
}

.lg {
  width: 88px;
  height: 88px;
  font-size: var(--text-2xl);
  border-width: 2px;
}
